import { createFileRoute } from '@tanstack/react-router'
import AdminMaintenanceJobsPage from '@/components/pages/Admin/AdminMaintenanceJobsPage/AdminMaintenanceJobsPage'

export const Route = createFileRoute('/$workspaceName/$environment/admin/maintenance-jobs')({
  component: AdminMaintenanceJobsRoute,
})

function AdminMaintenanceJobsRoute() {
  return <AdminMaintenanceJobsPage />
}
